<mat-form-field style="margin: 0 1em">
  <mat-label>JMESPath mapping</mat-label>
  <textarea matInput [value]="block.mapping" (change)="onMappingUpdate($event.target.value)"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="5"></textarea>
</mat-form-field>
